export default __webpack_public_path__ + "static/media/secti_logo_2023.b38e09c5.png";